import { ChangeEvent } from 'react'

import { useRouter } from 'next/router'

import ArrowDown from 'src/icons/ArrowDown'
import useSWR from 'swr'

import { ThemesCollectionsDocument } from '@/generated/contentful'

import { client } from '@/lib/contentful/client'
import { serializeCacheKey, useSlug } from '@/lib/contentful/utils'

export function ThemesIndustriesDropdown() {
	const router = useRouter()
	const slug = useSlug()

	const { data: industries } = useSWR(
		serializeCacheKey('themesIndustries', { ThemesIndustriesDropdown }),
		() =>
			client().request(ThemesCollectionsDocument, {
				where: {
					type: 'industry'
				}
			})
	)

	const handleOnChange = (e: ChangeEvent<HTMLSelectElement>) => {
		if (e.target.value === 'theme-store') {
			router.push('/theme-store')
		} else {
			router.push(`/theme-store/${e.target.value}`)
		}
	}

	return (
		<div className="lg:w-[357px] relative flex items-center focus-within:drop-shadow-lg">
			<select
				data-testid="category-select"
				className="w-full h-full rounded-md py-3 px-4 focus:outline-none border-0 bg-white text-bc-black ring-1 ring-gray-1000 focus:ring-gray-1000 sm:text-sm sm:leading-6 bg-none"
				onChange={(e) => handleOnChange(e)}
				value={
					industries?.themePropertyCollection?.items.find((industry) => industry?.slug === slug)
						?.slug ?? 'theme-store'
				}
			>
				{industries?.themePropertyCollection?.items
					.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''))
					.map((industry) => (
						<option key={industry?.slug} value={industry?.slug!}>
							{industry?.name}
						</option>
					))}
			</select>

			<ArrowDown className="text-gray-900 absolute right-5 pointer-events-none" />
		</div>
	)
}
